module.exports = __webpack_public_path__ + "8879a15de9bd061e36a5e7978792fa48.jpg";